import React, { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import './assets/scss/global.scss'
import { routes } from 'router'
import QueryProvider from 'shared/components/queryClient'
import { CMSProvider } from 'shared/context/cmsContext'

function App() {
  return (
    <>
      <QueryProvider>
        {(queryClient) => (
          <Suspense fallback={null}>
            <CMSProvider>
              <RouterProvider router={routes(queryClient)} />
            </CMSProvider>
          </Suspense>
        )}
      </QueryProvider>
    </>
  )
}

export default App
